import Model from '@/models/Model'

export default class PosCustomerCreditOption extends Model {
    resource() {
        return 'pos_customer_credit_option'
    }
}